import toastr from 'toastr';

export const AdminUsers = {
  state: {
    users: [],
    disablingUserAdmin: false,
    enablingUserAdmin: false,
    verifyingUser: false,
    rejectingUser: false,
    disablingUser: false,
    enablingUser: false,
    selectedUser: null,
    hospitalsList: [],
    sectionsList: [],
    specialityList: [],
    notificationsControl: {
      community_education: { mobileFlag: 0, emailFlag: 1, mobileAvailable: 0, emailAvailable: 1 },
      shared_with_me: { mobileFlag: 1, emailFlag: 1, mobileAvailable: 1, emailAvailable: 1 },
      activities_in_my_cases: { mobileFlag: 1, emailFlag: 1, mobileAvailable: 1, emailAvailable: 1 },
      activities_by_users_i_follow: { mobileFlag: 1, emailFlag: 1, mobileAvailable: 1, emailAvailable: 1 },
      activities_in_cases_i_follow: { mobileFlag: 1, emailFlag: 1, mobileAvailable: 1, emailAvailable: 1 },
      when_mentioned: { mobileFlag: 1, emailFlag: 1, mobileAvailable: 1, emailAvailable: 1 },
      case_groups: { mobileFlag: 1, emailFlag: 1, mobileAvailable: 1, emailAvailable: 1 },
      all_notifications: { mobileFlag: 1, emailFlag: 1, mobileAvailable: 1, emailAvailable: 1 },
    },
    usersDevices: null,
    gettingUsersDevices: false,
  },

  getters: {
    usersGetNotificationsControl: (state) => state.notificationsControl,
    disablingUserAdmin: (state) => state.disablingUserAdmin,
    usersGetSpecialityList: (state) => state.specialityList,
    enablingUserAdmin: (state) => state.enablingUserAdmin,
    usersGetHospitalsList: (state) => state.hospitalsList,
    usersGetSectionsList: (state) => state.sectionsList,
    disablingUser: (state) => state.disablingUser,
    rejectingUser: (state) => state.rejectingUser,
    verifyingUser: (state) => state.verifyingUser,
    enablingUser: (state) => state.enablingUser,
    getUser: (state) => state.selectedUser,
    getUsersDevices: (state) => state.usersDevices || {},
    gettingUsersDevices: (state) => state.gettingUsersDevices,
  },

  mutations: {
    setSelectedUser(state, user) {
      state.selectedUser = user;
    },
    usersSetAvatarSelectedUser(state, avatar) {
      state.selectedUser.avatarUrl = avatar;
    },
    usersSetHospitalsList(state, hospitalsList) {
      state.hospitalsList = hospitalsList;
    },
    usersSetSectionsList(state, sectionsList) {
      state.sectionsList = sectionsList;
    },
    usersAddSpecialities(state, specialityList) {
      state.specialityList.push(...specialityList);
    },
    usersSetNotificationsControl(state, notificationsControl) {
      for (const key of Object.keys(notificationsControl)) {
        state['notificationsControl'][key] = { ...state['notificationsControl'][key], ...notificationsControl[key] };
      }
    },
    setVerifyingUser(state, bool) {
      Vue.set(state, 'verifyingUser', bool);
    },
    setRejectingUser(state, bool) {
      Vue.set(state, 'rejectingUser', bool);
    },
    setEnablingUser(state, bool) {
      Vue.set(state, 'enablingUser', bool);
    },
    setDisablingUser(state, bool) {
      Vue.set(state, 'disablingUser', bool);
    },
    setEnablingUserAdmin(state, bool) {
      Vue.set(state, 'enablingUserAdmin', bool);
    },
    setDisablingUserAdmin(state, bool) {
      Vue.set(state, 'disablingUserAdmin', bool);
    },
    setUsersDevices(state, { userId, devices }) {
      Vue.set(state, 'usersDevices', { ...(state.usersDevices || {}), [userId]: devices });
    },
    setGettingUsersDevices(state, bool) {
      Vue.set(state, 'gettingUsersDevices', bool);
    },
  },

  actions: {
    async requestUser(ctx, userId) {
      if (userId) {
        ctx.commit('setBusy', true);

        let response = await this._vm.$api('users.show', { version: '1.0', user: userId });
        ctx.commit('setSelectedUser', response.data.data);
        ctx.commit('usersSetNotificationsControl', response.data.data.notificationsControl);
        ctx.commit('setBusy', false);
      }
    },
    async updateUser(ctx, userFormData) {
      ctx.commit('setBusy', true);

      const response = await this._vm.$api('users.update', { version: '1.0', user: userFormData.userId }, userFormData);

      ctx.commit('setBusy', false);
      ctx.commit('setSelectedUser', response.data.data);
      ctx.commit('usersSetNotificationsControl', response.data.data.notificationsControl);
      toastr.success('Data saved successfully');
    },
    async createUser(ctx, { form, redirect }) {
      ctx.commit('setBusy', true);
      const response = await this._vm.$api('users.store', { version: '1.0' }, form);
      ctx.commit('setBusy', false);
      if (typeof redirect === 'string') {
        window.location.replace(redirect);
      } else {
        window.location.replace(response.data.redirect);
      }
    },
    async usersRequestHospitalsList(ctx) {
      //let hospitals = apiRequest.getHospitalsList(this._vm.$api);
      let response = await this._vm.$api('api.get.hospitals', { version: '1.0' });
      ctx.commit('usersSetHospitalsList', response.data.data);
    },
    async usersRequestSectionsList(ctx) {
      let response = await this._vm.$api('api.get.sections', { version: '1.0' });
      ctx.commit('usersSetSectionsList', response.data.data);
    },
    async usersRequestSpecialityList(ctx) {
      let response = await this._vm.$api('api.get.specialities', { version: '1.0' });
      ctx.commit('usersAddSpecialities', response.data.data);
    },

    async verifyUser({ commit }, id) {
      commit('setVerifyingUser', true);
      try {
        await this._vm.$api(
          'verify-user',
          {},
          {
            id,
          }
        );
      } catch (err) {
        console.error(err);
      }
      commit('setVerifyingUser', false);
    },

    async rejectUser({ commit }, id) {
      commit('setRejectingUser', true);
      try {
        await this._vm.$api(
          'reject-user',
          {},
          {
            id,
          }
        );
      } catch (err) {
        console.error(err);
      }
      commit('setRejectingUser', false);
    },

    async enableUser({ commit }, radiologist_id) {
      commit('setEnablingUser', true);
      try {
        await this._vm.$api(
          'delete-radiologist',
          {},
          {
            radiologist_id,
            active: true,
          }
        );
      } catch (err) {
        console.error(err);
      }
      commit('setEnablingUser', false);
    },

    async disableUser({ commit }, radiologist_id) {
      commit('setDisablingUser', true);
      try {
        await this._vm.$api(
          'delete-radiologist',
          {},
          {
            radiologist_id,
            active: false,
          }
        );
      } catch (err) {
        console.error(err);
      }
      commit('setDisablingUser', false);
    },

    async enableNextUser({ commit }, radiologist_id) {
      commit('setEnablingUser', true);
      try {
        await this._vm.$api(
          'users.next.whitelist.update',
          { user: radiologist_id },
          {
            enabled: true,
          }
        );
      } catch (err) {
        console.error(err);
      }
      commit('setEnablingUser', false);
    },

    async disableNextUser({ commit }, radiologist_id) {
      commit('setDisablingUser', true);
      try {
        await this._vm.$api(
          'users.next.whitelist.update',
          { user: radiologist_id },
          {
            enabled: false,
          }
        );
      } catch (err) {
        console.error(err);
      }
      commit('setDisablingUser', false);
    },

    async enableUserAdmin({ commit }, radiologist_id) {
      commit('setEnablingUserAdmin', true);
      try {
        await this._vm.$api(
          'update-admin-radiologist',
          {},
          {
            radiologist_id,
            admin: true,
          }
        );
      } catch (err) {
        console.error(err);
      }
      commit('setEnablingUserAdmin', false);
    },

    async disableUserAdmin({ commit }, radiologist_id) {
      commit('setDisablingUserAdmin', true);
      try {
        await this._vm.$api(
          'update-admin-radiologist',
          {},
          {
            radiologist_id,
            admin: false,
          }
        );
      } catch (err) {
        console.error(err);
      }
      commit('setDisablingUserAdmin', false);
    },

    async usersRequestDevicesList({ commit }, userId) {
      commit('setGettingUsersDevices', true);
      try {
        let response = await this._vm.$api('users.devices', { version: '1.0', user: userId });
        let data = response.data;
        if (!Array.isArray(data)) {
          data = [];
        }
        commit('setUsersDevices', { userId, devices: data });
      } catch (error) {
        commit('setUsersDevices', { userId, devices: [] });
        console.log(error);
      } finally {
        commit('setGettingUsersDevices', false);
      }
    },

    async deleteDevices({ commit }, { userId, devices }) {
      await this._vm.$api('user.remove-devices', { version: '1.0', user: userId, devices: devices });
    },
  },
};
